import styled from 'styled-components'

const ReadonlyAudioTextTime = styled.p`
  font-size: ${p => p.theme.fonts.$s};
  font-style: italic;
`

ReadonlyAudioTextTime.displayName = 'ReadonlyAudioTextTime'
export default ReadonlyAudioTextTime
